import { render, staticRenderFns } from "./AdsCampaignForm.vue?vue&type=template&id=68ca785c"
import script from "./AdsCampaignForm.vue?vue&type=script&lang=js"
export * from "./AdsCampaignForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports